import { Box, Typography, Button } from "@mui/material";
import { useRef, useState } from "react";
import {useTranslation} from "react-i18next";
import {PAGE_APPLICATIONS} from "../../../locales/pages/namespaces";

const MAX_FILES = 20;
const MAX_SIZE_MB = 10;

const UploadDropzone = ({ onFilesAdded }) => {
    const inputRef = useRef(null);
    const [dragging, setDragging] = useState(false);
    const { t } = useTranslation(PAGE_APPLICATIONS);
    const handleFiles = (files) => {
        const validFiles = Array.from(files).filter(
            f => f.size <= MAX_SIZE_MB * 1024 * 1024
        );
        onFilesAdded(validFiles.slice(0, MAX_FILES));
    };

    return (
        <Box
            onDragOver={(e) => {
                e.preventDefault();
                setDragging(true);
            }}
            onDragLeave={() => setDragging(false)}
            onDrop={(e) => {
                e.preventDefault();
                setDragging(false);
                handleFiles(e.dataTransfer.files);
            }}
            sx={{
                border: "2px dashed",
                borderColor: dragging ? "#1976d2" : "#90caf9",
                backgroundColor: dragging ? "#e3f2fd" : "#e1f5fe",
                p: 4,
                borderRadius: 1,
                textAlign: "center",
                transition: "all 0.2s ease",
            }}
        >
            <Typography fontWeight={600}>
                {t("Drop your files here")}
            </Typography>

            <Typography mt={1} fontSize={14}>
                {t('Otherwise press the button to choose a file from your device')}
            </Typography>

            <Typography mt={2} fontSize={13} color="text.secondary">
                {t('Up to 20 files 10MB size each')}
            </Typography>

            <Button
                variant="outlined"
                sx={{ mt: 3 }}
                onClick={() => inputRef.current.click()}
            >
                {t('Choose files')}
            </Button>

            <input
                ref={inputRef}
                type="file"
                hidden
                multiple
                onChange={(e) => handleFiles(e.target.files)}
            />
        </Box>
    );
};

export default UploadDropzone;
